/**
 * Gets the authentication token from localStorage with error checking
 * @returns {string} The authentication token
 * @throws {Error} If no token is found
 */
export const getAuthToken = () => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Authentication token not found");
  }
  return token;
};

/**
 * Creates headers with authentication token for API requests
 * @param {Object} additionalHeaders - Any additional headers to include
 * @returns {Object} Headers object with Authorization and Content-Type
 */
export const getEnhancedAuthHeaders = (additionalHeaders = {}) => {
  const token = getAuthToken();
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
    ...additionalHeaders,
  };
};

/*
 * This function gets the most recent token data from local storage
 */

export const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    Authorization: `Bearer ${token}`,
  };
};
